import {filtersToAppliedFilters} from './filtersToAppliedFilters';
import {usePotentialFilters} from './usePotentialFilters';

export const useAppliedPotentialFilters = () => {
  const {filters} = usePotentialFilters();
  return filtersToAppliedFilters(filters);
};
